import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmService {
  private baseUrl = `${environment.baseUrl}lead-stages`;

  constructor(private http: HttpClient) {}

  getLeadStages(propertyId: string): Observable<any> {
    const params = new HttpParams().set('propertyId', propertyId);
    return this.http.get<any>(this.baseUrl, { params });
  }

  saveLeadStages(propertyId: string, stages: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl, { propertyId, stages });
  }

  getFollowupStatuses(propertyId: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}followup-status/${propertyId}`);
  }

  updateFollowupStatus(id: string, followupStatus: string, manualStatusLock: boolean, selectedLeadStages: string[]): Observable<any> {
    return this.http.patch<any>(`${environment.baseUrl}users/crm-followups/${id}/status`, { followupStatus, manualStatusLock, selectedLeadStages });
  }
}
